module.exports = __webpack_public_path__ + "img/vk.1d0c930.png";